import { render, staticRenderFns } from "./VSelectFacebookPage.vue?vue&type=template&id=6f013d42&scoped=true&"
import script from "./VSelectFacebookPage.vue?vue&type=script&lang=ts&"
export * from "./VSelectFacebookPage.vue?vue&type=script&lang=ts&"
import style0 from "./VSelectFacebookPage.vue?vue&type=style&index=0&id=6f013d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f013d42",
  null
  
)

export default component.exports